import { useEffect, useState } from 'react';
import EcomEngineAPI from 'api/ecom_engine_api';
import { trackError } from 'utils/helpers';

export const useEventFilter = () => {
  const [fetchedEvents, setFetchedEvents] = useState([]);
  // type status = 'idle'|'loading'|'succeed'|'failed';
  const [status, setStatus] = useState('idle');
  const [month, setMonth] = useState(null);
  const limit = 0;

  useEffect(() => {
    if (!month) {
      return;
    }
    const fetchData = () => {
      const params = month === '0' ? { limit } : { month, limit };
      setStatus('loading');
      EcomEngineAPI.entry
        .getEvents(params)
        .then((res) => {
          setFetchedEvents(res);
          setStatus('succeed');
        })
        .catch((error) => {
          trackError(error);
          setStatus('failed');
        });
    };
    setFetchedEvents([]);
    fetchData();
  }, [month]);

  return [fetchedEvents, status, setMonth];
};

export const useMonths = () => {
  const [months, setMonths] = useState([]);
  const [status, setIsLoading] = useState();

  useEffect(() => {
    const fetchData = () => {
      setIsLoading(true);
      EcomEngineAPI.entry
        .getEventMonths()
        .then((res) => {
          setMonths(res);
        })
        .catch((err) => {
          trackError(err);
        })
        .finally(() => {
          setIsLoading(false);
        });
    };
    setMonths([]);
    fetchData();
  }, []);

  return [months, status];
};
